module.exports = __webpack_public_path__ + "img/step2.fd4081e8.png";